import { useCallback } from 'react';

import { useLazyQuery } from '@apollo/client/react';

import { MdAccountSelectQuery, MdAccountSelectQueryVariables } from '@anyx/common-graphql';


import { ACCOUNT_SELECT } from '../graphql';

export type MdAccountSelectQueryOptions = useLazyQuery.Options<
  MdAccountSelectQuery,
  MdAccountSelectQueryVariables
>;
export const useAccountSelect = () => {
  const [queryMdAccount, { loading }] = useLazyQuery(ACCOUNT_SELECT);

  const getAccountDetails = useCallback(
    async ({ accountId }: { accountId: string }) => {
      if (!accountId) return;

      const { data } = await queryMdAccount({
        variables: {
          id: accountId,
        },
      });
      return data?.MdAccount;
    },
    [queryMdAccount]
  );

  return {
    loading,
    getAccountDetails,
  };
};
